// extracted by mini-css-extract-plugin
export default {"Text":"SummaryCard_Text__v1sk7","Figures":"SummaryCard_Figures__rEnRk","Shadow":"SummaryCard_Shadow__Os-a8"};